// EmptyState.jsx
import React from "react";

function EmptyState({ imageSrc, imageAlt, title, subtitle, buttonText, buttonHref }) {
    return (
        <div className="flex min-h-[400px] flex-col items-center justify-center gap-6">
            <img
                src={imageSrc || "/placeholder.svg"}
                alt={imageAlt}
                width={280}
                height={200}
                className="object-contain"
            />

            <div className="text-center">
                <h3 className="text-2xl font-normal text-neutral-800">{title}</h3>
                {subtitle && <p className="mt-2 text-sm text-neutral-600">{subtitle}</p>}
            </div>

            <a
                href={buttonHref}
                className="h-11 border border-neutral-900 px-8 py-3 text-sm font-medium uppercase tracking-wide text-neutral-900 hover:bg-neutral-900 hover:text-white"
            >
                {buttonText}
            </a>
        </div>
    );
}

export default EmptyState;
